/* Layers ticker: constant speed regardless of copy length (seconds per screen width). */
(() => {
  if (customElements.get('layers-ticker')) return;
  class LayersTicker extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.lticker__track');
      if (!track) return;
      const set = () => {
        const half = track.scrollWidth / 2;
        const perScreen = Number(this.dataset.speed) || 20;
        track.style.animationDuration = (half / Math.max(1, this.offsetWidth)) * perScreen + 's';
      };
      set();
      new ResizeObserver(set).observe(this);
    }
  }
  customElements.define('layers-ticker', LayersTicker);
})();
